import { Icon } from "../Icon.js";
import generic_home_default from "../static/generic-home.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconGenericHome.tsx
/* istanbul ignore file -- @preserve */
const IconGenericHome = ({ color, height, style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: generic_home_default,
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconGenericHome };